// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"2d5cbc66","425":"57b51484","510":"fdb422f2","532":"414d80e7","633":"872310d9","634":"6f9a4538","922":"d9127d82","937":"62d7d55a","972":"f14b08c1"}[chunkId] + ".chunk.js";
};